export default __webpack_public_path__ + "static/media/info-icon.f5b5a0a4.svg";